import { ICommonPageParams } from '@/screens/CommonPage/domain/CommonPage.domain';
import { fetchBlogs } from './fetchBlogs';

export async function fetchBlogsByCategory(params: ICommonPageParams) {
    return fetchBlogs(params);
}
